__turbopack_context__.v({
  "author": "centered-module-scss-module__XBS1hG__author",
  "blink": "centered-module-scss-module__XBS1hG__blink",
  "content": "centered-module-scss-module__XBS1hG__content",
  "h1": "centered-module-scss-module__XBS1hG__h1",
  "hero": "centered-module-scss-module__XBS1hG__hero",
  "heroContent": "centered-module-scss-module__XBS1hG__heroContent",
  "heroImage": "centered-module-scss-module__XBS1hG__heroImage",
  "heroImageContain": "centered-module-scss-module__XBS1hG__heroImageContain",
  "heroText": "centered-module-scss-module__XBS1hG__heroText",
});
